import React, { useEffect, useState } from "react";
import DetailBlock from "../../common/DetailBlock";
import { RiBankFill } from "react-icons/ri";
import { AiFillCalendar } from "react-icons/ai";
import Body from "../../components/Body";
import { cloneDeep } from "lodash";
import Table from "../../common/Table";
import LabelText from "../../common/LabelText";
import addPrecision from "../../common/addPrecision";
import numberFormat from "../../common/numberFormat";
import AppButton from "../../common/AppButton";
import api from "../../config/api";
import AppInput from "../../common/AppInput";
import colors from "../../config/colors";
import config from "../../config/config";
import { observer } from "mobx-react-lite";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getOrganizationByid } from "../../stores/OrganizationStore";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLocations } from "../../stores/LocationStore";

const header = [
  { title: "Service Description", name: "serviceDescription" },
  { title: "Hours", name: "hours" },
  { title: "Rate", name: "rate" },
  { title: "Amount", name: "amount" },
];
const size = 25;
function GenerateInvoice() {
  const navigate = useNavigate();
  const location = useLocation();
  const { job } = useParams();
  const org = location.state.data.organization;
  const queryClient = useQueryClient();

  const { data: organization } = useQuery({
    queryFn: () => getOrganizationByid(org),
    queryKey: ["organization", org],
  });

  const { data: locations } = useQuery({
    queryFn: () => getLocations(),
    queryKey: ["locations"],
  });

  const [data, setData] = useState({
    ...location.state.data,
    invoiceDate: new Date(),
  });

  useEffect(() => {
    if (organization) {
      setData((cur) => ({
        ...cur,
        invoiceAddress: `${organization?.name}\n${organization?.careOf}`,
      }));
    }
  }, [organization]);

  const [disabled, setDisabled] = useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const handleChange = ({ target }) => {
    const name = target.name;
    const value = target.value;
    setDisabled(false);
    setData({ ...data, [name]: value });
  };
  const handleGenerate = async () => {
    setDisabled(true);
    const { pathname } = location;

    const res = await api.put("jobs", {
      _id: job,
      invoiceCreated: true,
      invoiceDate: data.invoiceDate,
      invoiceAddress: data.invoiceAddress,
    });

    if (!res.ok) {
      setDisabled(false);
      return toast.error(res.originalError.message);
    }
    setDisabled(false);
    queryClient.invalidateQueries(["jobs"]);

    return navigate(String(pathname).replace("invoice", "invoiceToPdf"), {
      state: {
        data: cloneDeep({
          ...data,
          location: data?.location?.map((x) =>
            locations?.find((item) => item._id === x)
          ),
        }),
      },
    });
  };

  useEffect(() => {
    const table = document.getElementsByClassName("x-table")[0];
    table.classList.remove("app-table");
  }, []);

  return (
    <Body title="Generate Invoice">
      <form onSubmit={handleSubmit}>
        <div className="d-flex" style={{ flexDirection: "column" }}>
          <DetailBlock
            style={{
              width: 800,
              backgroundColor: "transparent",
              boxShadow: "none  ",
            }}
          >
            <div className="d-flex" style={{ justifyContent: "space-between" }}>
              <LabelText
                columnMode
                placeholder="Invoice ID"
                label="Invoice ID"
                value={data.invoiceID}
              />
              {data.poNo && (
                <LabelText
                  columnMode
                  placeholder="PO No"
                  label="Po No"
                  value={data.poNo}
                />
              )}
              <LabelText
                columnMode
                placeholder="Tax Reg No."
                label="Tax Reg No."
                value="81600 6993 RT 0001"
              />
            </div>
            <br />
            <br />
            <AppInput
              label="Invoice Address"
              autoFocus
              type="textArea"
              name="invoiceAddress"
              onChange={({ target }) => {
                setData({ ...data, invoiceAddress: target.value });
              }}
              leftIcon={<RiBankFill size={size} color={colors.silver} />}
              floatLabel
              value={data.invoiceAddress}
              inputType="text"
              required
            />
            <Table header={header} data={data.detailsTable} />
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div
                style={{
                  display: "flex",
                  width: 300,
                  gap: 10,
                  flexDirection: "column",
                }}
              >
                <LabelText
                  label="Subtotal"
                  value={`$ ${addPrecision(numberFormat(data.subtotal))}`}
                />
                <LabelText
                  label="HST( % )"
                  value={`${addPrecision(numberFormat(data.tax))}`}
                />
                <LabelText
                  label="Total"
                  value={`$ ${addPrecision(numberFormat(data.total))}`}
                />
              </div>
            </div>
          </DetailBlock>
          <div
            className="d-flex"
            style={{ justifyContent: "flex-end", margin: "10px 0px" }}
          >
            <div>
              <AppInput
                label="Invoice Date"
                floatLabel
                leftIcon={
                  <AiFillCalendar
                    color={colors.silver}
                    size={config.iconSize}
                  />
                }
                onChange={handleChange}
                name="invoiceDate"
                placeholder="Invoice Date"
                datePicker
                value={data.invoiceDate}
                required
                type="date"
              />
              <AppButton
                disabled={disabled}
                onClick={handleGenerate}
                className="btn-primary"
                text="Generate"
              />
            </div>
          </div>
        </div>
      </form>
    </Body>
  );
}
export default observer(GenerateInvoice);
